var _g, _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSponsoredVideoWithProductSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8439_45518)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 70,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.3,
    y: 8.3,
    width: 83.4,
    height: 25.4,
    rx: 3.7,
    stroke: "var(--secondary-2)",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 63.4839,
    height: 22,
    rx: 2,
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2105 22.488L40.4263 26.2068C39.2436 27.1261 37.5558 26.2515 37.5558 24.7193L37.5558 17.2817C37.5558 15.7495 39.2436 14.8748 40.4263 15.7942L45.2105 19.513C46.1673 20.2567 46.1673 21.7442 45.2105 22.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.4839,
    y: 10,
    width: 14.5161,
    height: 14.5161,
    rx: 2.41935,
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0852 14.3186C80.0419 14.3278 79.9681 14.3535 79.9213 14.3757C79.8045 14.4311 79.6489 14.5832 79.5924 14.6973C79.5098 14.8643 79.5141 14.7152 79.5177 17.3006L79.5211 19.6473L79.555 19.7384C79.6353 19.9533 79.8047 20.1158 80.0212 20.1852L80.1136 20.2148H82.742H85.3703L85.4627 20.1852C85.6792 20.1158 85.8486 19.9533 85.9289 19.7384L85.9628 19.6473L85.9662 17.3006C85.9699 14.7152 85.9741 14.8643 85.8915 14.6973C85.8351 14.5835 85.6794 14.4311 85.5631 14.3759C85.394 14.2958 85.5626 14.3003 82.7356 14.3011C80.6189 14.3017 80.15 14.3048 80.0852 14.3186ZM83.9026 15.3969C84.0508 15.4419 84.1884 15.5467 84.2807 15.6849C84.5063 16.0227 84.3741 16.4872 84.0011 16.6671C83.5481 16.8857 83.027 16.592 82.9862 16.0953C82.9595 15.7706 83.2044 15.4533 83.5393 15.3786C83.6402 15.3561 83.794 15.3639 83.9026 15.3969ZM81.8569 16.7905C81.8826 16.8035 81.9205 16.8314 81.9411 16.8526C81.9617 16.8738 82.2566 17.247 82.5966 17.6819C83.1646 18.4086 83.2202 18.4757 83.2823 18.51C83.3632 18.5546 83.4647 18.5599 83.544 18.5235C83.5709 18.5112 83.6869 18.4113 83.8018 18.3014C84.0225 18.0904 84.0471 18.0748 84.1608 18.0746C84.2358 18.0745 84.329 18.1249 84.3828 18.1946C84.4866 18.329 85.1556 19.2692 85.183 19.3192C85.2339 19.412 85.2141 19.4968 85.1326 19.5346C85.0929 19.5531 84.8919 19.5548 82.7903 19.5548C80.577 19.5548 80.4897 19.554 80.4474 19.532C80.389 19.5016 80.3467 19.439 80.3471 19.3834C80.3472 19.3589 80.3603 19.3084 80.3761 19.2711C80.4389 19.1228 81.6114 16.8695 81.643 16.8364C81.7088 16.7674 81.7803 16.752 81.8569 16.7905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.4839,
    y: 26.5166,
    width: 9.92556,
    height: 1.12903,
    rx: 0.564516,
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.4839,
    y: 29.6455,
    width: 5.92556,
    height: 1.12903,
    rx: 0.564516,
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 40,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6259 46.2191C14.5635 46.2323 14.4573 46.2693 14.3899 46.3012C14.2217 46.381 13.9976 46.6001 13.9163 46.7644C13.7973 47.0049 13.8034 46.7901 13.8087 50.5131L13.8136 53.8924L13.8625 54.0235C13.978 54.333 14.2221 54.5669 14.5337 54.6669L14.6667 54.7095H18.4516H22.2365L22.3695 54.6669C22.6812 54.5669 22.9252 54.333 23.0408 54.0235L23.0897 53.8924L23.0945 50.5131C23.0998 46.7901 23.106 47.0049 22.9869 46.7644C22.9058 46.6004 22.6815 46.381 22.514 46.3016C22.2706 46.1862 22.5134 46.1926 18.4425 46.1938C15.3945 46.1947 14.7193 46.1992 14.6259 46.2191ZM20.123 47.7718C20.3364 47.8366 20.5345 47.9875 20.6673 48.1865C20.9923 48.673 20.8019 49.3418 20.2648 49.6009C19.6125 49.9156 18.862 49.4928 18.8033 48.7775C18.7649 48.3099 19.1176 47.853 19.5998 47.7455C19.7451 47.7131 19.9665 47.7242 20.123 47.7718ZM17.1771 49.7786C17.2141 49.7973 17.2687 49.8375 17.2984 49.868C17.328 49.8986 17.7528 50.4359 18.2423 51.0622C19.0602 52.1086 19.1403 52.2052 19.2297 52.2546C19.3462 52.3189 19.4924 52.3264 19.6066 52.2741C19.6453 52.2564 19.8123 52.1125 19.9778 51.9542C20.2956 51.6503 20.3311 51.6279 20.4948 51.6277C20.6027 51.6276 20.737 51.7001 20.8145 51.8004C20.9639 51.9939 21.9273 53.3479 21.9668 53.4199C22.04 53.5535 22.0115 53.6757 21.8942 53.7301C21.837 53.7567 21.5476 53.7592 18.5212 53.7592C15.3341 53.7592 15.2084 53.7579 15.1475 53.7263C15.0633 53.6825 15.0025 53.5924 15.003 53.5123C15.0032 53.4771 15.022 53.4044 15.0448 53.3506C15.1353 53.1371 16.8236 49.8924 16.8691 49.8447C16.9639 49.7453 17.0669 49.7232 17.1771 49.7786Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 63.2256,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 67.1738,
    width: 14.2928,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 40,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1743 46.2191C46.1119 46.2323 46.0057 46.2693 45.9383 46.3012C45.7701 46.381 45.546 46.6001 45.4647 46.7644C45.3457 47.0049 45.3518 46.7901 45.3571 50.5131L45.362 53.8924L45.4109 54.0235C45.5264 54.333 45.7705 54.5669 46.0821 54.6669L46.2151 54.7095H50H53.7849L53.9179 54.6669C54.2296 54.5669 54.4736 54.333 54.5892 54.0235L54.6381 53.8924L54.6429 50.5131C54.6482 46.7901 54.6544 47.0049 54.5353 46.7644C54.4542 46.6004 54.2299 46.381 54.0624 46.3016C53.819 46.1862 54.0618 46.1926 49.9909 46.1938C46.9429 46.1947 46.2677 46.1992 46.1743 46.2191ZM51.6714 47.7718C51.8848 47.8366 52.0829 47.9875 52.2157 48.1865C52.5407 48.673 52.3503 49.3418 51.8132 49.6009C51.1609 49.9156 50.4104 49.4928 50.3517 48.7775C50.3133 48.3099 50.666 47.853 51.1482 47.7455C51.2935 47.7131 51.5149 47.7242 51.6714 47.7718ZM48.7255 49.7786C48.7625 49.7973 48.8171 49.8375 48.8468 49.868C48.8764 49.8986 49.3012 50.4359 49.7907 51.0622C50.6086 52.1086 50.6887 52.2052 50.7781 52.2546C50.8946 52.3189 51.0408 52.3264 51.155 52.2741C51.1937 52.2564 51.3607 52.1125 51.5262 51.9542C51.844 51.6503 51.8795 51.6279 52.0432 51.6277C52.1511 51.6276 52.2854 51.7001 52.3629 51.8004C52.5123 51.9939 53.4757 53.3479 53.5152 53.4199C53.5884 53.5535 53.5599 53.6757 53.4426 53.7301C53.3854 53.7567 53.096 53.7592 50.0696 53.7592C46.8825 53.7592 46.7568 53.7579 46.6959 53.7263C46.6117 53.6825 46.5509 53.5924 46.5514 53.5123C46.5516 53.4771 46.5704 53.4044 46.5932 53.3506C46.6837 53.1371 48.372 49.8924 48.4175 49.8447C48.5123 49.7453 48.6153 49.7232 48.7255 49.7786Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 63.2256,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 67.1738,
    width: 14.2928,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 40,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7227 46.2191C77.6603 46.2323 77.5541 46.2693 77.4867 46.3012C77.3184 46.381 77.0944 46.6001 77.0131 46.7644C76.894 47.0049 76.9002 46.7901 76.9055 50.5131L76.9103 53.8924L76.9592 54.0235C77.0748 54.333 77.3188 54.5669 77.6305 54.6669L77.7635 54.7095H81.5484H85.3333L85.4663 54.6669C85.778 54.5669 86.022 54.333 86.1375 54.0235L86.1865 53.8924L86.1913 50.5131C86.1966 46.7901 86.2027 47.0049 86.0837 46.7644C86.0025 46.6004 85.7783 46.381 85.6108 46.3016C85.3673 46.1862 85.6102 46.1926 81.5393 46.1938C78.4912 46.1947 77.816 46.1992 77.7227 46.2191ZM83.2198 47.7718C83.4332 47.8366 83.6312 47.9875 83.7641 48.1865C84.089 48.673 83.8987 49.3418 83.3616 49.6009C82.7093 49.9156 81.9588 49.4928 81.9001 48.7775C81.8617 48.3099 82.2143 47.853 82.6966 47.7455C82.8419 47.7131 83.0633 47.7242 83.2198 47.7718ZM80.2739 49.7786C80.3109 49.7973 80.3655 49.8375 80.3951 49.868C80.4248 49.8986 80.8495 50.4359 81.3391 51.0622C82.157 52.1086 82.237 52.2052 82.3265 52.2546C82.443 52.3189 82.5892 52.3264 82.7034 52.2741C82.7421 52.2564 82.9091 52.1125 83.0746 51.9542C83.3924 51.6503 83.4279 51.6279 83.5916 51.6277C83.6995 51.6276 83.8337 51.7001 83.9112 51.8004C84.0607 51.9939 85.0241 53.3479 85.0635 53.4199C85.1368 53.5535 85.1082 53.6757 84.991 53.7301C84.9338 53.7567 84.6444 53.7592 81.618 53.7592C78.4309 53.7592 78.3052 53.7579 78.2443 53.7263C78.1601 53.6825 78.0992 53.5924 78.0998 53.5123C78.1 53.4771 78.1188 53.4044 78.1416 53.3506C78.2321 53.1371 79.9204 49.8924 79.9658 49.8447C80.0607 49.7453 80.1637 49.7232 80.2739 49.7786Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 63.2256,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 67.1738,
    width: 14.2928,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 69,
    rx: 5.5,
    stroke: "var(--secondary-1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8439_45518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 70,
    rx: 6,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsoredVideoWithProductSoon);
export default __webpack_public_path__ + "static/media/sponsored-video-with-product-soon.e2e62178863d7d9d7dcbf2cf7b9ba2bb.svg";
export { ForwardRef as ReactComponent };